export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('stateTabs');
    if (serializedState === null) {
      return undefined;
    }
    return { tabs: JSON.parse(serializedState) };
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state.tabs);
    sessionStorage.setItem('stateTabs', serializedState);
  } catch {
    // ignore write errors
  }
};
